import { Link } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { WhatsappBspOverviewMessages } from "@/messages/platforms/whatsappBspConnection/whatsappBspOverviewMessages";

interface Props {
  messages: WhatsappBspOverviewMessages;
}

export function Overview({ messages }: Props) {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {messages.whatsappBspOverviewText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.whatsappBspOverviewText2}
        </MDTypography>

        <MDTypography variant="body2" color="text">
          {messages.whatsappBspOverviewText3}
          <Link target="_blank" href={messages.whatsappBspOverviewArticleLinkSource}>
            <MDTypography component="span" variant="body2" fontWeight="bold" color="primary">
              {messages.whatsappBspOverviewArticleLinkText}
            </MDTypography>
          </Link>
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

